module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/51bK5iPrkgqzqtPBdP0M6R-43dcb3df8d42ffd6bcf38285c439486a.jpg";